import { BREAKPOINT } from '../constants';

export function TwoColContent() {
  const desktopVal = BREAKPOINT.desktop;
  const mediaQuery = window.matchMedia(`screen and (min-width: ${desktopVal}px)`);

  function getTwocolcontent() {
    if (mediaQuery.matches) {
      const titleMaxHeight = getMaxHeight('[data-mh="title-group"]');
      const subtitleMaxHeight = getMaxHeight('[data-mh="subtitle-group"]');
      const descriptionMaxHeight = getMaxHeight('[data-mh="description-group"]');

      setHeight('[data-mh="title-group"]', titleMaxHeight);
      setHeight('[data-mh="subtitle-group"]', subtitleMaxHeight);
      setHeight('[data-mh="description-group"]', descriptionMaxHeight);
    } else {
      resetHeight('[data-mh="title-group"]');
      resetHeight('[data-mh="subtitle-group"]');
      resetHeight('[data-mh="description-group"]');
    }
  }

  function getMaxHeight(attributeSelector) {
    const elements = document.querySelectorAll(attributeSelector);
    let maxHeight = 0;

    elements.forEach(element => {
      maxHeight = Math.max(maxHeight, element.offsetHeight);
    });

    return maxHeight;
  }

  function setHeight(attributeSelector, height) {
    const elements = document.querySelectorAll(attributeSelector);

    elements.forEach(element => {
      element.style.height = `${height}px`;
    });
  }

  function resetHeight(attributeSelector) {
    const elements = document.querySelectorAll(attributeSelector);

    elements.forEach(element => {
      element.style.height = 'auto';
    });
  }

  // Call the function initially
  getTwocolcontent();

  // Add event listener for window resize
  window.addEventListener('resize', getTwocolcontent);
}



// WEBPACK FOOTER //
// ./src/btu/js/components/TwoColContent.js